import React, { createContext, useContext, useMemo, useState } from "react";

const PageLoadingContext = createContext({
  isPageLoading: false,
  setPageLoading: () => {},
});

export const PageLoadingProvider = ({ children }) => {
  const [isPageLoading, setPageLoading] = useState(false);

  const value = useMemo(
    () => ({ isPageLoading, setPageLoading }),
    [isPageLoading]
  );

  return (
    <PageLoadingContext.Provider value={value}>
      {children}
    </PageLoadingContext.Provider>
  );
};

export const usePageLoading = () => useContext(PageLoadingContext);
